import { useStore } from '@/store/useStore';
import { CheckCircle2, Info, AlertTriangle, XCircle, X, Loader2 } from 'lucide-react';
import { cn } from '@/utils/cn';

const ICONS = { info: Info, success: CheckCircle2, warn: AlertTriangle, error: XCircle };
const COLORS = {
  info: 'text-accent', success: 'text-status-paid',
  warn: 'text-status-partial', error: 'text-status-refused',
};

export function Toasts() {
  const toasts = useStore((s) => s.toasts);
  const dismiss = useStore((s) => s.dismissToast);
  const attachmentSaving = useStore((s) => s.attachmentSaving);
  return (
    <>
      {/* Плашка «фото уходит на сервер» — снизу по центру, чтобы не мешать кнопкам и
          тостам (те справа). Пока идёт хоть одно сохранение с вложением — просим не
          закрывать страницу; исчезает сама, когда все отправки завершились. */}
      {attachmentSaving > 0 && (
        <div className="fixed bottom-6 inset-x-0 z-[121] flex justify-center px-4 pointer-events-none">
          <div className="panel shadow-pop animate-in flex items-center gap-2.5 py-2 px-4 max-w-sm">
            <Loader2 className="w-4 h-4 flex-shrink-0 text-accent animate-spin" />
            <span className="text-sm text-ink-1">Фото загружается — не закрывайте страницу…</span>
          </div>
        </div>
      )}
      <div className="fixed bottom-6 right-6 z-[120] flex flex-col gap-2 max-w-sm">
      {toasts.map((t) => {
        const Icon = ICONS[t.kind];
        return (
          <div key={t.id} className="panel shadow-pop animate-in flex items-start gap-3 p-3 pr-10 relative">
            <Icon className={cn('w-5 h-5 flex-shrink-0 mt-0.5', COLORS[t.kind])} />
            <div className="flex-1 text-sm text-ink-1">{t.text}</div>
            <button className="absolute top-2 right-2 icon-btn !w-6 !h-6" onClick={() => dismiss(t.id)} aria-label="Закрыть">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        );
      })}
      </div>
    </>
  );
}
